import styled from '@emotion/styled';
import css from '@styled-system/css';

import { InputContainer } from '../InputContainer';
import { Container, IconContainer } from '../ValidationIcon';

export const TextAreaContainer = styled(InputContainer)((props) => {
  return css({
    ':hover': {
      borderColor: props.focus ? 'input.focus.color' : 'neutral.90',
    },
    [`+ ${Container} ${IconContainer}`]: {
      margin: 0,
      alignItems: 'end',
    },
    [`&:hover + ${Container}`]: {
      borderColor: props.focus ? 'input.focus.color' : 'neutral.90',
    },
  });
});
